import { Space } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Loading } from 'components/atoms/loading';
import { Modal } from 'components/atoms/modal';
import { Caption01, SingleLineEllipsis, Text03 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';

export const ModalWithStyledFooter = styled(Modal)`
  .ant-modal-footer {
    border-top: solid 1px var(--border-color);
    padding: var(--layout-01);
  }
`;

export const AddToProjectModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const PrimaryTitle = styled.div``;

const SecondaryTitle = styled.div`
  ${Caption01};
  ${SingleLineEllipsis};
  opacity: 0.5;
`;

const LoaderWrapper = styled.div`
  height: 416px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingMessage = styled.div`
  ${Text03};
  color: var(--gray-70);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface Props {
  primaryTitle: ReactNode;
  secondaryTitle?: ReactNode;
}

export const ModalTitle: FC<Props> = ({ primaryTitle, secondaryTitle }) => {
  return (
    <>
      <PrimaryTitle>{primaryTitle}</PrimaryTitle>
      {secondaryTitle ? (
        <SecondaryTitle>{secondaryTitle}</SecondaryTitle>
      ) : null}
    </>
  );
};

export const ModalContentLoader: FC<{ loadingText?: ReactNode }> = ({
  loadingText,
}): JSX.Element => {
  const loading = useTranslation('loading');

  return (
    <LoaderWrapper>
      <Space direction="vertical" size={16} align="center">
        <Loading size="large" />
        <LoadingMessage>{loadingText ?? loading}</LoadingMessage>
      </Space>
    </LoaderWrapper>
  );
};
